<script setup>
import {usePiniaStore} from "../../store/pinia_store";

const props = defineProps({
    eventBus: {
        type: Object,
        required: true
    },
    items: {
        type: Object,
        required: true,
    },
    dentaidApiInstance: {
        type: Function,
        required: true,
    },
    cartEventBus: {
        type: Object,
        required: true,
    }
})


const piniaStore = usePiniaStore();
</script>

<template>
    <div class="vue-cart">
        <dentaid-cart-row
            v-for="item in items"
            :item="item"
            :key="item.sku"
            :event-bus="eventBus"
            :jwt-token="piniaStore.parsedToken"
            :dentaid-api-instance="dentaidApiInstance"
            :cart-event-bus="cartEventBus"
        ></dentaid-cart-row>
    </div>
</template>